export default __webpack_public_path__ + "upload/Andrey.f779e0b4.png";